'use client';

import { c as _c } from "react/compiler-runtime";
import { UserAvatar } from '@/components/images/user-avatar';
import { cn } from '@/lib/ui/utils';
export interface ProposalBackersOutcomesStackBacker {
  address: string;
  displayName: string | null;
  avatarUrl: string | null;
  avatarNsfw: boolean;
}
interface ProposalBackersOutcomesStackProps {
  topBackers: ProposalBackersOutcomesStackBacker[];
  /** Maximum avatars shown (default 5). 24px circles overlap by 50% (−12px). */
  cap?: number;
  className?: string;
}
const DEFAULT_CAP = 5;

/**
 * Overlapping top-backer avatars for the proposal detail hero footer row.
 * Only backers — no outcome markers.
 */
export function ProposalBackersOutcomesStack(t0) {
  const $ = _c(10);
  const {
    topBackers,
    cap: t1,
    className
  } = t0;
  const cap = t1 === undefined ? DEFAULT_CAP : t1;
  let t2;
  let t3;
  if ($[0] !== cap || $[1] !== className || $[2] !== topBackers) {
    const seen = new Set();
    const uniqueBackers = topBackers.filter(b => {
      if (seen.has(b.address)) {
        return false;
      }
      seen.add(b.address);
      return true;
    }).slice(0, cap);
    if ($[5] !== className) {
      t2 = cn("flex items-center", className);
      $[5] = className;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    t3 = uniqueBackers.map(_temp);
    $[0] = cap;
    $[1] = className;
    $[2] = topBackers;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = <div className={t2}>{t3}</div>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}
function _temp(b_0, idx) {
  return <span key={`backer-${b_0.address}`} className={cn(idx > 0 && "-ml-3")}><UserAvatar size="xs" userId={b_0.address} displayName={b_0.displayName} avatarUrl={b_0.avatarUrl} nsfw={b_0.avatarNsfw} rasterise={false} borderWidth={1} borderColor="border-background-secondary" /></span>;
}